import {Component} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-task-confirm',
  templateUrl: './task-confirm.component.html'
})
export class TaskConfirmComponent {

  constructor(public activeModal: NgbActiveModal) {
  }

}
